import React, { useState, useEffect } from "react"
// import "./SearchTeacher.css"
import Pagination from "../../../Components/Pagination/Pagination"
import CollegePageContainer from "../../Container/CollegePageContainer"
import { connect } from "react-redux"
import { addRemoveFavouriteTeacher } from "../../../redux/college/college.actions"
import { API } from "../../../API"
import SearchCard from "../../../Components/SearchCard/SearchCard"
import { filterTeacherCriterias, getClassCategories, getCurrentPage } from "../../../Helper"
import SearchBar from "../../../Components/SearchBar/SearchBar"
import { createUserObject } from "../../Profile/profile.utils"
import Spinner from "../../../Components/Spinner/Spinner"
import { notify } from "react-notify-toast"

const ViewApplicants = (props) => {
  let [isLoaded, setIsLoaded] = useState(false)
  let [pageNum, setPageNum] = useState(1)
  let [allApplicants, setAllApplicants] = useState([])
  let [allInterviewees, setAllInterviewees] = useState([])
  let [showCurrentUsers, setShowCurrentUsers] = useState([]) // current page of results
  let [searchResults, setSearchResults] = useState([]) // all search results
  let [searchKeyword, setSearchKeyword] = useState("")
  let [searchLocation, setSearchLocation] = useState("")
  let [searchCategory, setSearchCategory] = useState("all")
  let [job, setJob] = useState({})
  let [campuses, setCampuses] = useState([])
  const job_id = props.match.params.id

  useEffect(() => {
    // todo: get applicants/job details

    API.getListingById(job_id)
      .then(res => {
        setJob(res.data.listing)
      })

    API.getMultipleCampusById(props.institution.campuses).then(res => {
      setCampuses(res.data)
    }).catch(err => {
      console.log(err.response)
    })

    API.getInterviewees(job_id)
      .then(res => {
        setAllInterviewees(res.data.listings.map(t => t._id))
      }).catch(err => {
      console.log(err.response)
    })

    API.getApplicants(job_id)
      .then(res => {
        const teachers = res.data.listings.map(t => {
          return {
            ...t,
            can_delivers: createUserObject(t, true)
          }
        });
        const uniqueTeachers = [];
        teachers.forEach(teacher => {
          if (!uniqueTeachers.find(t => t._id === teacher._id)) {
            uniqueTeachers.push(teacher);
          }
        })
        setAllApplicants(uniqueTeachers)
        setSearchResults(uniqueTeachers)
        handlePage(pageNum, uniqueTeachers)
        setIsLoaded(true)
      })
      .catch(err => {
        console.log(err.response)
        setIsLoaded(true)
      })
    // setIsLoaded(true)
  }, [])

  // Show 10 users per page ------
  let handlePage = (pageNumber, teachers) => {
    setShowCurrentUsers(getCurrentPage(pageNumber, teachers))
    setPageNum(pageNumber)
  }

  const onPageNumChange = (e) => {
    handlePage(e.target.getAttribute("value"), searchResults)
  }

  const search = ({ keyword, category, location }) => {
    let kw = (keyword !== undefined ? keyword : searchKeyword).toLowerCase();
    let cat = (category !== undefined ? category : searchCategory).toLowerCase();
    let catArr = [];
    switch (cat) {
      case "all":
        catArr = [];
        break;
      case "all-eng":
        catArr = categories.filter((c) => c.type === "eng").map((c) => c.value);
        break;
      case "all-vet":
        catArr = categories.filter((c) => c.type === "vet").map((c) => c.value);
        break;
      default:
        catArr = [cat];
        break;
    }
    let loc = (location !== undefined ? location : searchLocation).toLowerCase();

    if (kw || cat || loc) {
      if (allApplicants.length > 0) {
        let filteredTeachers = allApplicants.filter((teacher) => {
          let searchFilter = filterTeacherCriterias(teacher)
          let catMatch = false;
          for (let c of catArr) {
            if (searchFilter.category.includes(c)) catMatch = true;
          }
          if (!catArr.length) catMatch = true;

          return (searchFilter.keyword.includes(kw)
            && catMatch
            && searchFilter.location.includes(loc)
          )
        })
        handlePage(pageNum, filteredTeachers)
        setSearchResults(filteredTeachers)
      }
    } else {
      setSearchResults(allApplicants)
      handlePage(pageNum, allApplicants)
    }
  };

  const onSearchCategory = (e) => {
    let category = e.target.id;
    setSearchCategory(category)
    search({ category })
  }

  const onChangeKeyword = (e) => {
    let keyword = e.target.value;
    setSearchKeyword(keyword)
    search({ keyword })
  }

  const onChangeLocation = (e) => {
    let location = e.target.value;
    setSearchLocation(location)
    search({ location })
  }

  const tabs = [
    {
      text: "Job Listing",
      pathname: `/JobListing/${job_id}`,
    },
    {
      text: "View Applicants",
      pathname: `/JobListing/Applicants/${job_id}`,
      active: true
    }
  ]

  let categories = getClassCategories();
  categories.unshift(
    { value: "all", name: "Show All" }
  )

  const requestInterview = (teacher) => {
    API.inviteToInterview(props.match.params.id, teacher._id)
      .then(res => {
        notify.show(`Interview requested for ${teacher.first_name} ${teacher.last_name}`)
        setAllInterviewees(interviewees => [...interviewees, teacher._id])
        let updatedInterviews = [...teacher.my_interviews];
        updatedInterviews.push({
          listing_id: job_id,
          date: new Date()
        })
        let updatedTeacher = {
          ...teacher,
          my_interviews: updatedInterviews
        }
        const newTeacherList = allApplicants.map(applicant => {
          if (applicant._id === teacher._id) {
            return updatedTeacher;
          }
          else {
            return applicant;
          }
        })
        setAllApplicants(newTeacherList)
        setSearchResults(newTeacherList)
        handlePage(pageNum, newTeacherList)
      })
      .catch(err => {
        console.log(err.response)
      })
  }

  const requestInterviewWithScheduler = (teacher, interviewScheduleInfo) => {
    console.log("teacher: ", teacher, interviewScheduleInfo)
    API.inviteToInterviewWithScheduler(props.match.params.id, teacher._id, interviewScheduleInfo)
      .then(res => {
        notify.show(`Interview requested for ${teacher.first_name} ${teacher.last_name}`)
        setAllInterviewees(interviewees => [...interviewees, teacher._id])
        let updatedInterviews = [...teacher.my_interviews];
        updatedInterviews.push({
          listing_id: job_id,
          date: new Date()
        })
        let updatedTeacher = {
          ...teacher,
          my_interviews: updatedInterviews
        }
        const newTeacherList = allApplicants.map(applicant => {
          if (applicant._id === teacher._id) {
            return updatedTeacher;
          }
          else {
            return applicant;
          }
        })
        setAllApplicants(newTeacherList)
        setSearchResults(newTeacherList)
        handlePage(pageNum, newTeacherList)
      })
      .catch(err => {
        console.log(err.response)
      })
  }

  const getInterviewTime = (teacher) => {
    return job.invited_interview.find((int) => int.teacher_id === teacher._id)?.interview_schedule_infos
  }

  return (
    <CollegePageContainer
      user={props.user}
      header="View Applicants"
      tabs={tabs}
      viewbookings={props.viewbookings}
    >
      <div className="search-teacher-container">
        <div className="search-teacher-filters">
          <div className="w-100 d-flex justify-content-center">
            <SearchBar
              placeholder="Search by Keyword"
              onChange={onChangeKeyword}
              altColours
            />
          </div>
          <hr className="my-3" />
          <h2 className="search-teacher-subheading">Category</h2>
          <ul className="search-teacher-categories">
            <li
              id="all-eng"
              onClick={onSearchCategory}
              style={{
                fontWeight: searchCategory === "all-eng" ? "bold" : "normal",
              }}
            >
              English (ELT)
            </li>
            <li
              id="all-vet"
              onClick={onSearchCategory}
              style={{
                fontWeight: searchCategory === "all-vet" ? "bold" : "normal",
              }}
            >
              Vocational (VET)/Digital & Tech
            </li>
          </ul>

          {/*
          <ul className="search-teacher-categories">
            {categories.map(cat => {
              return <li
                id={cat.value}
                onClick={onSearchCategory}
                style={{ fontWeight: searchCategory === cat.value ? "bold" : "normal" }}
              >
                {cat.name}
              </li>
            })}
          </ul>
          */}

          <hr className="my-3" />
          <h2 className="search-teacher-subheading">Location</h2>
          <div className="w-100 d-flex justify-content-center">
            <SearchBar
              placeholder="Search Locations"
              onChange={onChangeLocation}
              altColours
            />
          </div>
        </div>
        <div className="search-teacher-main">

          <h2 className="search-teacher-heading my-3">{job.title}: Applicants</h2>
          <div className="d-flex flex-wrap justify-content-center flex-grow-1">
            {isLoaded ?
              (searchResults.length ?
                showCurrentUsers.map((user) => {
                  return <SearchCard
                    user={user}
                    campuses={campuses}
                    isFaved={props.institution.fav_teacher_list.includes(user._id)}
                    showInterviewButton
                    requestInterview={() => requestInterview(user)}
                    requestInterviewWithScheduler={(user, interviewScheduleInfo) => requestInterviewWithScheduler(user, interviewScheduleInfo)}
                    interviewRequested={allInterviewees.includes(user._id)}
                    interviewTime={getInterviewTime(user)}
                  />
                })
                :
                "No results found.")
              :
              <div className="spinner spinner-5"/>
            }
          </div>

          {searchResults.length ?
            <Pagination
              itemArray={searchResults}
              pageNum={pageNum}
              onPageNumChange={onPageNumChange}
            />
            : null}

        </div>
      </div>
    </CollegePageContainer>
  )
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    // viewbookings: (state.college.user.permissions) ? state.college.user.permissions & (1 << permIndices.vi_book) : 1,
    viewbookings: state.college.permissions.vi_book
  }
}

const mapDispatchToProps = {
  addRemoveFavouriteTeacher,
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewApplicants)
